(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/regenerator", "@babel/runtime/helpers/asyncToGenerator", "query-string", "axios", "js-cookie"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/asyncToGenerator"), require("query-string"), require("axios"), require("js-cookie"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.asyncToGenerator, global.queryString, global.axios, global.jsCookie);
    global.noperm = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _regenerator, _asyncToGenerator2, _queryString, _axios, _jsCookie) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  _regenerator = _interopRequireDefault(_regenerator);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _queryString = _interopRequireDefault(_queryString);
  _axios = _interopRequireDefault(_axios);
  _jsCookie = _interopRequireDefault(_jsCookie);

  var instance = _axios["default"].create({
    baseURL: "//rd-ewx-login-service-server.qutoutiao.net",
    headers: {
      "Content-Type": "application/json"
    },
    withCredentials: false
  });

  var _default = {
    // 跳转登陆
    login: function login(_ref) {
      var _ref$app = _ref.app,
          app = _ref$app === void 0 ? "" : _ref$app,
          _ref$url = _ref.url,
          url = _ref$url === void 0 ? window.location.href : _ref$url,
          _ref$state = _ref.state,
          state = _ref$state === void 0 ? "" : _ref$state,
          _ref$copyright = _ref.copyright,
          copyright = _ref$copyright === void 0 ? JSON.stringify({
        guardian: "",
        // 维护人
        team: {
          name: "",
          // 开发组
          link: "" // 组介绍连接

        },
        feedback: "" // 反馈连接

      }) : _ref$copyright;
      window.location.href = "".concat(instance.defaults.baseURL, "/login?app=").concat(app, "&redirect_url=").concat(encodeURIComponent(url), "&state=").concat(state, "&copyright=").concat(copyright);
    },
    getToken: function getToken() {
      var token = _queryString["default"].parse(window.location.search.slice(1)).token || '';

      if (!token) {
        token = _jsCookie["default"].get('ewx-token');
      }

      return token;
    },
    // 获取用户信息
    getUserInfo: function getUserInfo() {
      return (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee() {
        var tokenInUrl, tokenInCookie, token, hostname, res;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tokenInUrl = _queryString["default"].parse(window.location.search.slice(1)).token;
                tokenInCookie = _jsCookie["default"].get("ewx-token");
                token = tokenInUrl || tokenInCookie || '';

                if (token) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", null);

              case 5:
                if (tokenInUrl) {
                  hostname = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/gim.exec(window.location)[1];

                  _jsCookie["default"].set("ewx-token", token, {
                    expires: 7,
                    domain: hostname === "localhost" || /\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b/gim.test(hostname) ? hostname : "." + hostname
                  });
                }

                _context.next = 8;
                return instance.post("/api/userinfo", {
                  token: token
                });

              case 8:
                res = _context.sent;

                if (!(res.status === 200 && !res.data.code)) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", res.data.response);

              case 13:
                return _context.abrupt("return", null);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 登出
    logout: function logout() {
      return (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2() {
        var tokenInUrl, tokenInCookie, token, res;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                tokenInUrl = _queryString["default"].parse(window.location.search.slice(1)).token;
                tokenInCookie = _jsCookie["default"].get("ewx-token");
                token = tokenInUrl || tokenInCookie || '';

                if (token) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", null);

              case 5:
                _context2.next = 7;
                return instance.post("/api/logout", {
                  token: token
                });

              case 7:
                res = _context2.sent;

                if (res.status === 200) {
                  if (!res.data.code) {
                    _jsCookie["default"].remove("ewx-token");
                  }
                }

                return _context2.abrupt("return", true);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  };
  _exports["default"] = _default;
});


//////////////////
// WEBPACK FOOTER
// ./~/@qtt/ewx-login-sdk/lib/noperm.js
// module id = 262
// module chunks = 24